// import { prefixPath } from '@/config'

export default function (index) {
  const config = this.dynamicList[index]
  if (!config) return []
  const list = config.formPropertyList.map(item => {
    if (item.propertyConfig && item.propertyConfig.indexOf('session_listOrgId') > -1) {
      item.propertyConfig = item.propertyConfig.replace('session_listOrgId', this.orgId)
    }
    if (item.propertyConfig && item.propertyConfig.indexOf('prefixPath') > -1) {
      item.propertyConfig = item.propertyConfig.replace('prefixPath', 'api-uum/')
    }
    const props = JSON.parse(item.propertyConfig || '{}')
    if (item.widgetType === 'fileUpload') {
      props.data = props.data || {}
      props.data.groupId = this.groupId
      props.isShowFileList = true
    }
    if (item.widgetType === 'InputNumber') {
      props.min = 0
    }
    if (item.widgetType === 'selectInputMember') {
      props.bizLineCode = props.bizLineCode || this.bizLineCode
      props.isAllResult = props.isAllResult || true
    }
    if (item.widgetType === 'universalTree' && props.treeParams) {
      if (props.treeParams.orgId === '') {
        props.treeParams.orgId = -1
      }
      props.treeParams.bizLineCode = props.treeParams.bizLineCode || this.bizLineCode
    }
    if (item.propertyCode === 'userName') {
      item.isReadonly = 1
    }
    //码表接口前缀
    if (props.url && props.url.indexOf('api-general') < 0 && props.params && props.params.dictCode) {
      props.url = 'api-general/module/portal/user/outGetList'
      props.params.bizLineCode = this.bizLineCode
    }
    if (item.description) {
      props.extra = true
    }
    if (config.groupType == 1) { //表单
      return item.isEnabled == 1 ? {
        type: item.widgetType || 'Input',
        title: item.displayName || item.propertyName,
        [$field]: item.propertyCode,
        colSpan: item.colspan || 8,
        description: item.description || '',
        readOnly: item.isReadonly == 1 ? true : false,
        props: props,
        rules: item.isNotNull == 1 ? ['required'] : []
      } : null
    } else { //表格
      return item.isEnabled == 1 ? {
        showType: item.widgetType || '',
        title: item.displayName || item.propertyName,
        [$field]: item.propertyCode,
        width: item.width || null,
        minWidth: item.minWidth || null,
        readOnly: item.isReadonly == 1 ? true : false,
        props: props
      } : null
    }
  }).filter(v => v)
  if (config.groupType != 1) {
    list.push({
      'title': '操作',
      'width': 120,
      [$field]: 'operate',
      'isOperate': true
    })
  }
  return config.isEnabled == 1 ? list : []
}